import type { UserInfoCardProps } from "./types-user-info-card";
import { useUserInfoCard } from "./use-user-info-card";
import { UserInfoCardView } from "./view-user-info-card";

/** Cartão do usuário ao passar o cursor sobre o gatilho (`children`): foto, nome, e-mail com copiar, telefone e detalhe. */
export function UserInfoCard(props: UserInfoCardProps) {
  const vm = useUserInfoCard(props);

  return <UserInfoCardView {...vm} />;
}

export type * from "./types-user-info-card";
